export default "__VITE_ASSET__DTnyEHx4__"